<template>
    <div class="error-msg-wrap">
        <div class="form-wrapper slide-up" style="width:520px">
            <div class="form-close">
                <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
            </div>
            <h2 class="pg-modal-title">Check In</h2>
            <div class="pg-modal-sub">{{ goal.Name }}</div>

            <template v-if="goal.TrackType == 'number'">
                <div class="pg-label">Where Are You Now?</div>
                <div class="pg-number-row">
                    <input type="number" v-model="currentValue" aria-label="Where you are now" ref="first" />
                    <span>of {{ formatNumber(goal.TargetValue) }} {{ goal.Unit }}</span>
                </div>
            </template>
            <template v-else-if="goal.TrackType == 'steps'">
                <div class="pg-label">Steps</div>
                <p v-if="!stepsDone.length" class="pg-hint" style="margin:0">This goal has no steps. Add them from the goal.</p>
                <label v-for="(s, i) in goal.Steps" :key="i" class="pg-check">
                    <input type="checkbox" v-model="stepsDone[i]" /> {{ s.Text }}
                </label>
            </template>
            <label v-else class="pg-check" style="margin-top:18px">
                <input type="checkbox" v-model="done" /> It's done
            </label>

            <div class="pg-label">How's It Going?</div>
            <div class="pg-seg">
                <button v-for="s in statuses" :key="s.value" type="button" :class="status == s.value ? 'on' : ''" @click="status = s.value">{{ s.label }}</button>
            </div>

            <div class="pg-label">Note</div>
            <textarea v-model="note" rows="3" placeholder="What moved? What's in the way? What do you need?"></textarea>

            <div v-if="goal.CheckIns.length" class="pg-history">
                <b>Earlier Check-Ins</b>
                <div v-for="c in goal.CheckIns.slice(0, 4)" :key="c.ID"><span>{{ dateLabel(isoDate(new Date(c.Date))) }}</span>{{ c.Note }}</div>
            </div>

            <div class="pg-actions">
                <span style="flex:1"></span>
                <div class="btn-light" @click="$emit('close')">Cancel</div>
                <div class="btn" :class="saving ? 'disable-button' : ''" @click="save()">Save Check-In</div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import { STATUSES, isoDate, dateLabel, formatNumber } from '@/personalGoals';

export default defineComponent({
    name: 'PersonalGoalCheckInModal',
    // goal: one of your goals
    props: [ 'goal' ],
    emits: [ 'close', 'saved' ],
    data() {
        return {
            statuses: STATUSES,
            currentValue: this.goal.CurrentValue ?? this.goal.StartValue ?? 0,
            stepsDone: this.goal.Steps.map((s: any) => !!s.Done),
            done: !!this.goal.Done,
            status: this.goal.Status,
            note: '',
            saving: false
        }
    },
    mounted() {
        (this.$refs.first as HTMLInputElement)?.focus();
    },
    methods: {
        isoDate,
        dateLabel,
        formatNumber,
        async save() {
            if(this.saving) {
                return;
            }
            this.saving = true;
            await axios.post(`${this.$store.state.apiUrl}/api/personalgoals/checkin`, {
                ID: this.goal.ID,
                CurrentValue: this.currentValue,
                StepsDone: this.stepsDone,
                Done: this.done,
                Status: this.status,
                Note: this.note
            })
                .then(() => {
                    this.$emit('saved');
                })
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error');
                })
            this.saving = false;
        }
    }
});
</script>
